export default __webpack_public_path__ + "static/media/MarvelLogo.8bc2d60e.svg";